import { defineStore, acceptHMRUpdate } from 'pinia';

import { getServices } from '~/db/services';

export const useVersionsStore = defineStore('VersionsStore', () => {
  if (!useAppRunningStore().isRunning) return;

  const runtimeConfig = useRuntimeConfig();

  const { $db } = useNuxtApp();

  const { versionsService } = getServices($db);

  const hasBeenInitialized = ref<boolean>(false);

  const previousVersion = ref<string>(null);
  const currentVersion = ref<string>(null);

  const getFromUserLoggedIn = async () => {
    if (hasBeenInitialized.value) return;
    previousVersion.value = await versionsService.get();
    currentVersion.value = runtimeConfig.public.appVersion;
    await versionsService.save(currentVersion.value);
    hasBeenInitialized.value = true;
  };

  const initFromUserLogin = async () => {
    currentVersion.value = runtimeConfig.public.appVersion;
    previousVersion.value = runtimeConfig.public.appVersion;
    await versionsService.save(currentVersion.value);
    hasBeenInitialized.value = true;
  };

  const reset = () => {
    hasBeenInitialized.value = false;
  };

  const needForceFullUpdate = (): boolean => {
    if (!versionIsGreaterThanOrEqual(previousVersion.value, '8.2.0'))
      return true;
    return false;
  };

  return {
    getFromUserLoggedIn,
    initFromUserLogin,
    previousVersion,
    currentVersion,
    needForceFullUpdate,
    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useVersionsStore, import.meta.hot));
}
